import { useState } from "react";
import { CheckboxList } from "../../UI/Table/Filters/CheckboxListFilter.tsx";
import { FilterActions } from "../../UI/Table/Filters/FilterActions.tsx";
import { toggleListValue } from "../../UI/Table/Filters/toggleListValue.ts";
import { matchesItemSearch } from "../../UI/Utils/matchesItemSearch.ts";

const OPTIONS_WITHOUT_SEARCH = 8;

export function ColumnValuesFilter({
  options,
  value,
  onApply,
  close,
}: {
  options: string[];
  value: string[];
  onApply: (selected: string[]) => void;
  close: () => void;
}) {
  const [selected, setSelected] = useState(value);
  const [search, setSearch] = useState("");
  const visibleOptions = options.filter((option) =>
    matchesItemSearch(search, [option]),
  );
  const apply = (values: string[]) => {
    onApply(values);
    close();
  };

  return (
    <div className="flex flex-col gap-2 px-2">
      {options.length > OPTIONS_WITHOUT_SEARCH && (
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Cerca"
          className="w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm"
        />
      )}
      <div className="max-h-64 overflow-y-auto">
        <CheckboxList
          options={visibleOptions.map((option) => ({
            value: option,
            label: <span className="break-words">{option}</span>,
          }))}
          selected={selected}
          onToggle={(toggled) =>
            setSelected((current) => toggleListValue(current, toggled))
          }
        />
        {visibleOptions.length === 0 && (
          <p className="py-2 text-center text-sm text-gray-400">
            Nessun risultato
          </p>
        )}
      </div>
      <FilterActions
        canClear={value.length > 0}
        onClear={() => apply([])}
        onApply={() => apply(selected)}
      />
    </div>
  );
}
